import { render, staticRenderFns } from "./AuthErrors.vue?vue&type=template&id=206cd660&scoped=true&"
import script from "./AuthErrors.vue?vue&type=script&lang=js&"
export * from "./AuthErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206cd660",
  null
  
)

export default component.exports